import { Button, SidebarTrigger, TabsList, TabsTrigger } from '@ibsys/kit';
import { LayoutGrid, MessageCirclePlus, MessagesSquare, SidebarIcon } from 'lucide-react';
import { FC } from 'react';
import { cn } from '@/shared/lib';
import { useMainLayout } from '@/shared/ui';
import { useCopilot } from '@/features/copilot';
import { useHasPermission } from '@/entities/profile';

type Props = {
  className?: string;
};

const triggerClassName = cn(
  'size-8 min-h-7 grow-0 text-sidebar-foreground transition-all',
  'data-[state=active]:bg-sidebar-accent data-[state=active]:text-sidebar-accent-foreground',
  'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
);

export const PanelsBar: FC<Props> = ({ className }) => {
  const {
    sidebar: { activePanel },
    isMobile,
  } = useMainLayout();
  const { createNewChat, showChatList } = useCopilot();
  // Кнопки чатов ИИ Агента доступны по разрешению использования ИИ Агента (в т.ч. выданному через роль).
  const canUseAiAgent = useHasPermission('USE_AI_AGENT');

  return (
    <TabsList
      className={cn(
        'bg-sidebar border-r border-sidebar-border rounded-none flex flex-col items-center justify-start py-4 gap-2 min-h-full',
        className,
      )}
    >
      {isMobile && (
        <SidebarTrigger>
          <SidebarIcon />
        </SidebarTrigger>
      )}
      <TabsTrigger asChild value={'navigation'} className={triggerClassName}>
        <Button
          icon={<LayoutGrid className="h-5 w-5" />}
          variant={activePanel === 'navigation' ? 'secondary' : 'ghost'}
          size="icon"
          aria-label="Toggle navigation"
        />
      </TabsTrigger>

      {canUseAiAgent && (
        <Button
          icon={<MessageCirclePlus className="h-5 w-5" />}
          variant="ghost"
          size="icon"
          className={cn('size-8 min-h-7', 'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground')}
          aria-label="New chat"
          onClick={createNewChat}
        />
      )}

      {canUseAiAgent && (
        <TabsTrigger asChild value={'copilot'} className={triggerClassName}>
          <Button
            icon={<MessagesSquare className="h-5 w-5" />}
            variant={activePanel === 'copilot' ? 'secondary' : 'ghost'}
            size="icon"
            aria-label="Chat list"
            onClick={showChatList}
          />
        </TabsTrigger>
      )}
    </TabsList>
  );
};
